import { createFileRoute } from '@tanstack/react-router'

import { DEFAULT_SUBSCRIPTION_TAB, resolveSubscriptionTab } from '#/pages/Subscriptions/interfaces'

interface ISubscriptionsSearch {
  page?: number
  tab?: string
}

export const Route = createFileRoute('/_authenticated/subscriptions')({
  validateSearch: (search: Record<string, unknown>): ISubscriptionsSearch => {
    // A retired tab name resolves to the tab that replaced it; anything else
    // unknown falls back to the default rather than rendering an empty
    // overview. The default itself stays out of the URL.
    const tab = resolveSubscriptionTab(search.tab)

    return {
      page: Number(search.page) > 1 ? Number(search.page) : undefined,
      tab: tab === DEFAULT_SUBSCRIPTION_TAB ? undefined : tab,
    }
  },
})
